import { Directive, ElementRef } from '@angular/core';
import { ModalComponent } from '../Component/modal';

@Directive({
    selector: '[autofocus]'
})
export class AutofocusDirective {
    constructor(private el: ElementRef, private modal: ModalComponent) {
        if (modal != null) {
            this.modal.onOpen.subscribe(() => {
                this.el.nativeElement.focus();
            });
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/shared/modeldialog/directives/autofocus.ts